import { get } from 'svelte/store';

import { toggleFavorite } from '@api/user';
import { favoritesStore } from '@components/favorite/store';
import type { AddFavoriteData } from '@components/favorite/types';
import { sendEvents } from '@components/room/chat/components/user-info/functions';
import { partnerStore } from '@components/room/partner/store';
import { toastsStore } from '@components/ui/toasts';
import LL from '@i18n/i18n-svelte';

export async function addUserToFavorite(data: AddFavoriteData) {
    const { id, displayName, inFavoriteList } = data.partner;
    const $LL = get(LL);
    const { ok, canCall } = await toggleFavorite(id, data.storyId);
    partnerStore.changeFavoriteList(!inFavoriteList);
    if (ok) {
        if (!inFavoriteList) {
            toastsStore.success($LL.favorites.added({ displayName }));
            favoritesStore.addFavorite({
                isOnline: data.partner.isOnline ?? true,
                displayName,
                haveTransactionLastYear: data.partner.haveTransactionLastYear ?? false,
                id,
                canCall,
                intId: data.partner.intId ?? 10,
                inMyFavorites: true,
                isBlocked: false,
                isBlockedBy: false,
            });
        } else {
            toastsStore.success($LL.favorites.removed({ displayName }));
            favoritesStore.deleteFavorite(id);
        }

        const userId = data.isOperator ? data.partner.id : data.ownId;
        const modelId = data.isOperator ? data.ownId : data.partner.id;

        sendEvents(!inFavoriteList, data.isDesktop, data.isOperator, data.place, userId, modelId, data.roomId);
    }
}
